export enum ScheduleState {
  UPCOMING = 'upcoming',
  IN_PROGRESS = 'inProgress',
  COMPLETED = 'completed',
}
